export default __webpack_public_path__ + "static/AromaHover-75eb059d5aa8db23d901b5ff99d92095.png";